'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotebookRIcon = function NotebookRIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M27.625 32H5.812a.722.722 0 0 1-.75-.75V.75c0-.438.313-.75.75-.75h21.813c.438 0 .75.313.75.75v30.5c0 .438-.313.75-.75.75zM6.563 30.563h20.375V1.438H6.563zm.687-24.75H4.375c-.438 0-.75-.313-.75-.75s.313-.688.75-.688H7.25c.438 0 .75.25.75.688s-.313.75-.75.75zm0 4.375H4.375c-.438 0-.75-.313-.75-.75s.313-.688.75-.688H7.25c.438 0 .75.25.75.688s-.313.75-.75.75zm0 4.375H4.375c-.438 0-.75-.313-.75-.75s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.75-.75.75zm0 4.375H4.375c-.438 0-.75-.313-.75-.75s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.75-.75.75zm0 4.312H4.375c-.438 0-.75-.25-.75-.688s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.688-.75.688zm0 4.375H4.375c-.438 0-.75-.25-.75-.688s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.688-.75.688zm6-5.937v-10.75h4.813c1 0 1.75.125 2.125.25.438.188.875.625 1.188 1 .313.438.438 1.063.438 1.625 0 .75-.313 1.438-.75 1.875-.438.625-1.25.875-2.313 1.063.438.125.75.25.875.563.438.438.875.875 1.188 1.438l1.875 2.938h-1.75l-1.438-2.188c-.438-.563-.75-1.188-1-1.438-.313-.438-.625-.625-.75-.75s-.438-.313-.563-.313h-2.5v4.813H13.25zm1.438-6h3.063c.563 0 1.188 0 1.625-.125s.563-.313.813-.563c.188-.313.313-.625.313-1.063 0-.563-.125-.875-.563-1.313-.438-.25-1-.438-1.75-.438h-3.5z' })
    );
};

exports.default = NotebookRIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/NotebookRIcon.js
// module id = 642
// module chunks = 0